module.exports = __webpack_public_path__ + "static/media/horizontalDots.4a259508.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/horizontalDots.svg
// module id = 1897
// module chunks = 0